import { ErrorMessage, Field, Formik } from "formik";
import React, { useState } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { IProductCategory } from "../../customTypings/ProductCategory";
import { productCategoryService } from "../../services";
import { showToastSuccess, showToastError } from "../../helpers";
import { LoadingSpinner } from "../../components/LoadingSpinner";

type Props = {
    show: boolean;
    onClose: (added: boolean) => void;
};

const ProductCategoryAddPage: React.FC<Props> = ({ show, onClose }) => {
    const [alertVariant, setAlertVariant] = useState("danger");

    const handleClose = () => onClose(false);

    return (
        <Modal centered show={show} keyboard={false} onHide={handleClose}>
            <Formik
                initialValues={{
                    name: "",
                }}
                onSubmit={(values, { setStatus, setSubmitting, setFieldError }) => {
                    setStatus();
                    setSubmitting(false);
                    const newProductCategory: IProductCategory = {
                        id: undefined,
                        name: values.name,
                    };

                    productCategoryService.add(newProductCategory).then(
                        (response) => {
                            setSubmitting(false);
                            if (response.status !== "Failure") {
                                setAlertVariant("success");
                                showToastSuccess("Product Category added successfully!");
                                setTimeout(() => onClose(true), 1000);
                            } else {
                                setAlertVariant("danger");
                                showToastError(response.message);
                            }
                        },
                        (error: any) => {
                            setAlertVariant("danger");
                            if (error.status === 400 && error.errors) {
                                Object.keys(error.errors).forEach((key) => {
                                    const messages = error.errors[key];
                                    if (Array.isArray(messages)) {
                                        messages.forEach((message) => showToastError(message));
                                    }
                                });
                            } else {
                                showToastError("An unexpected error occurred!");
                            }
                            setSubmitting(false);
                        }
                    );
                }}
            >
                {({ errors, status, touched, isSubmitting, handleSubmit, values, handleChange }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title>New Product Category</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group as={Row} className="mb-3" controlId="name">
                                <Form.Label column md={3}>
                                    Name <span style={{ color: 'red' }}>*</span>
                                </Form.Label>
                                <Col md={9}>
                                    <Field
                                        name="name"
                                        type="text"
                                        className={"form-control" + (errors.name && touched.name ? " is-invalid" : "")}
                                        value={values.name}
                                    />
                                    <ErrorMessage name="name" component="div" className="invalid-feedback" />
                                </Col>
                            </Form.Group>

                            {status && (
                                <Alert variant={alertVariant} className="mt-3">
                                    {status}
                                </Alert>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="form-group">
                                <Button variant="primary" disabled={isSubmitting} type="submit" className="me-2">
                                    {isSubmitting ? <LoadingSpinner text="Creating Product Category..." /> : "Create Product Category"}
                                </Button>
                                <Button variant="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export { ProductCategoryAddPage };
